module.exports = __webpack_public_path__ + "static/media/arrow_right_active.d3147a2d.svg";